
<div class="tab-pane  test-drive-wrapper show active dealer-review-row"
                id="pills-testDrive" role="tabpanel" aria-labelledby="pills-testDrive-tab">
                <div class="d-md-flex">
                  <h1 class="page-sub-title cv-text-dark mb-3 mb-md-0">
                    <a (click)="mobileBack()" class=""><img [src]='environment1 + "assets/images/c-arrow-left.svg"'
                        class="img-fluid me-2" loading="lazy" /></a>My Test Drive
                  </h1>
                  <ul class="nav nav-pills nav-fill mb-3 ms-auto" id="pills-tab-test-drive" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" [ngClass]="{'active' : status == 'upcoming'}" id="pills-upcoming-tab"
                        data-bs-toggle="pill" data-bs-target="#pills-upcoming" type="button" role="tab"
                        aria-controls="pills-upcoming" aria-selected="true"
                        (click)="onClickStatus('upcoming')">Upcoming</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" [ngClass]="{'active' : status == 'cancelled'}" id="pills-cancelled-tab"
                        data-bs-toggle="pill" data-bs-target="#pills-cancelled" type="button" role="tab"
                        aria-controls="pills-cancelled" aria-selected="false"
                        (click)="onClickStatus('cancelled')">Cancelled</button>
                    </li>
                  </ul>
                </div>

                <div class="tab-content" id="pills-tabContent-test-drive">
                  <ng-container *ngIf="status == 'upcoming'">
                    <ng-container *ngFor="let row of testDriveData | paginate: {
                      itemsPerPage: itemsPerPage,
                      currentPage: currentPage,
                      totalItems: totalItemsTD, id: 'testDriveUpcoming'
                    }">
                      <div class="tab-pane fade show active" id="pills-upcoming" role="tabpanel"
                        aria-labelledby="pills-upcoming-tab">
                        <div class="card-list mb-3">
                          <div class="card test-drive-card">
                            <div class="card-body">
                              <div class="card-content">
                                <div class="prod-item">
                                  <div class="prod-img">
                                    <a [routerLink]="redirect(row.product)">
                                      <img *ngIf="row?.product?.images[0]?.image_url" loading="lazy"
                                        src="{{row?.product?.images[0]?.image_url}}" class="img-responsive cursor"
                                        alt="product IMg">
                                    </a>
                                    <a [routerLink]="redirect(row.product)">
                                      <img *ngIf="!row?.product?.images[0]?.image_url" loading="lazy"
                                        [src]='environment1 + "assets/images/default_vehicle_img.webp"'
                                        class="img-responsive cursor" alt="product IMg">
                                    </a>
                                  </div>
                                  <div class="prod-info display-flex">
                                    <a [routerLink]="redirect(row.product)">
                                      <div class="title cursor width-title">{{row?.product?.model}}
                                      </div>
                                    </a>
                                    <div class="width-title d-flex">
                                      <div *ngIf="row?.opty_id" class="">
                                        <span>OPTY ID: </span> {{ row?.opty_id }}
                                      </div>
                                      <div *ngIf="row?.row_id" class="">
                                        <span>REQUEST ID: </span> {{ row?.row_id }}
                                      </div>
                                    </div>
                                  </div>

                                </div>

                              </div>
                              <div class="list-group">
                                <div class="address d-flex w-100">
                                  <img [src]='environment1 + "assets/images/new-images/map.svg"' alt="map" loading="lazy">
                                  {{row?.address_one}} {{row?.address_two}}- {{row?.city}} {{row?.state}}
                                  {{row?.district}} {{row?.pincode}}
                                </div>
                                <div class="date-time d-grid d-lg-flex gap-2 w-100">
                                  <div class="d-flex align-items-center">
                                    <img [src]='environment1 + "assets/images/new-images/calender.svg"' alt="calender" loading="lazy">
                                    Scheduled on {{row?.scheduled_on | date: 'EEEE, MMMM d, y' }}<br>
                                    {{ row.td_type }}
                                  </div>

                                  <div class="contact  ms-lg-auto text-nowrap me-lg-4">
                                    <img [src]='environment1 + "assets/images/new-images/telephone.svg"' alt="telephone" loading="lazy">
                                    +91 {{row?.mobile_number}}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states"
                      *ngIf="testDriveData?.length == 0">
                      <img [src]='environment1 + "assets/images/no_schedule_test_drive.svg"' loading="lazy">
                      <h3>
                        No Test Drives Scheduled
                      </h3>
                      <div class="desc">
                        You don't have any scheduled test drives at <br />
                        the moment.
                      </div>
                    </div>
                    <div class="col-xs-12 paging-custom">
                      <pagination-controls class="col-xs-12" *ngIf="totalItemsTD > itemsPerPage"
                        (pageChange)="pageChange($event)" previousLabel=" " nextLabel=" " id='testDriveUpcoming'
                        [maxSize]="maximumsizeupcoming"></pagination-controls>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="status == 'cancelled'">
                    <ng-container *ngFor="let row of testDriveData | paginate: {
                      itemsPerPage: itemsPerPage,
                      currentPage: currentPage,
                      totalItems: totalItemsTD, id: 'testDriveCancelled'
                    }">
                      <div class="tab-pane fade show active" id="pills-cancelled" role="tabpanel"
                        aria-labelledby="pills-cancelled-tab">
                        <div class="card-list mb-3">
                          <div class="card test-drive-card">
                            <div class="card-body">
                              <div class="card-content">
                                <div class="prod-item">
                                  <div class="prod-img" [routerLink]="redirect(row.product)">
                                    <img *ngIf="row?.product?.images[0]?.image_url"
                                      src="{{row?.product?.images[0]?.image_url}}" class="img-fluid cursor" alt="product IMg"
                                      loading="lazy">
                                    <img *ngIf="!row?.product?.images[0]?.image_url"
                                      [src]='environment1 + "assets/images/default_vehicle_img.webp"' class="img-fluid cursor"
                                      loading="lazy" alt="product IMg">
                                  </div>
                                  <div class="prod-info" [routerLink]="redirect(row.product)">
                                    <div class="title cursor d-flex align-items-center">
                                      {{row?.product?.model}}

                                      <!-- <a class="reschedule ms-auto d-none d-lg-block text-nowrap"
                                        href="javascript:void(0)">Reschedule Test Drive
                                        <img [src]='environment1 + "assets/images/new-images/edit.svg"' alt="edit" loading="lazy">
                                      </a> -->

                                    </div>
                                    <div class="status ms-md-auto">
                                      <div *ngIf="row?.opty_id">
                                        <span><b>OPTY ID:</b> {{ row?.opty_id }}</span>
                                      </div>
                                      <div *ngIf="row?.row_id">
                                        <span><b>REQUEST ID:</b> {{ row?.row_id }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="list-group">
                                <div class="address d-flex">
                                  <img [src]='environment1 + "assets/images/new-images/map.svg"' alt="map" loading="lazy">
                                  {{row?.address_one}} {{row?.address_two}}- {{row?.city}} {{row?.state}}
                                  {{row?.district}} {{row?.pincode}}
                                </div>
                                <div class="d-grid d-lg-flex gap-2 w-100">
                                  <div class="date-time d-flex">
                                    <img [src]='environment1 + "assets/images/new-images/calender.svg"' alt="calender" loading="lazy">
                                    Scheduled on {{row?.scheduled_on | date: 'EEEE, MMMM d, y' }}<br>
                                    {{ row.td_type }}
                                  </div>
                                  <div class="contact  ms-lg-auto text-nowrap me-lg-4">
                                    <img [src]='environment1 + "assets/images/new-images/telephone.svg"' alt="telephone" loading="lazy">
                                    +91 {{row?.mobile_number}}
                                  </div>
                                </div>

                              </div>
                              <!-- <div class="card-footer d-block d-lg-none">
                                <a class="reschedule ms-auto text-nowrap" href="javascript:void(0)">Reschedule Test
                                  Drive
                                  <img [src]='environment1 + "assets/images/new-images/edit.svg"' alt="edit" loading="lazy">
                                </a>
                              </div> -->
                            </div>

                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states"
                      *ngIf="testDriveData?.length == 0">
                      <img [src]='environment1 + "assets/images/no_schedule_test_drive.svg"' loading="lazy">
                      <h3>
                        No Test Drives Cancelled
                      </h3>
                      <div class="desc">
                        You don't have any cancelled test drives at <br />
                        the moment.
                      </div>
                    </div>
                    <div class="col-xs-12 paging-custom">
                      <pagination-controls class="col-xs-12" *ngIf="totalItemsTD > itemsPerPage"
                        (pageChange)="pageChange($event)" previousLabel=" " nextLabel=" " id='testDriveCancelled'
                        [maxSize]="maximumSize"></pagination-controls>
                    </div>
                  </ng-container>

                </div>

              </div>
